export const AI_SERVICE_CONFIG = {
  baseUrl: import.meta.env.VITE_AI_SERVICE_URL as string | undefined,
  enabled: import.meta.env.VITE_AI_SERVICE_ENABLED === 'true',
} as const;
